module.exports = __webpack_public_path__ + "static/media/ic-instagram.2093f986.svg";